<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="TocSb1" id="int"><a id="page_v"></a><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">Don’t Rely on Webster’s</span></a></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space1">Unmask Euphemisms</span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Remind People of What They Know</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Embrace Your Allusive Impulses</span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Tell It “Slant”</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">Promote Poetry</span></span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">Articulate Your Outrage</span></span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Find Facts and Check Them</span></span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">Mind Your Metaphors</span></span></p>
<p class="Toc" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">10.<span class="space05">Complicate Matters</span></span></p>
<p class="Toc" id="ch-011"><span href="#/xhtml/chapter011#ch011" title="Link target outside of Sample">11.<span class="space05">Laugh When You Can</span></span></p>
<p class="Toc" id="ch-012"><span href="#/xhtml/chapter012#ch012" title="Link target outside of Sample">12.<span class="space05">Quit Trying to “Win”</span></span></p>
<p class="Toc1" id="aft"><a id="page_vi"></a><span href="#/xhtml/afterword#aft" title="Link target outside of Sample">Afterword</span></p>
<p class="Toc1" id="que"><span href="#/xhtml/backmatter001#que" title="Link target outside of Sample">Questions for Discussion</span></p>
<p class="Toc1" id="note"><span href="#/xhtml/notes#note" title="Link target outside of Sample">Notes</span></p>
<p class="Toc1" id="bib"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1a5352ca